import Action from 'redux/helpers/createAction'
const name = 'favouriteLinks'

export const getFavouritesLists = Action(name + '/GET_LISTS')

export const getFavouritesListsSuccess = Action(name + '/GET_LISTS_SUCCESS', lists => ({
  lists
}))

export const getFavouritesListsFailure = Action(name + '/GET_LISTS_FAILURE', error => ({
  error
}))

export const getFavouritesList = Action(name + '/GET_LIST', id => ({
  id
}))

export const getFavouritesListSuccess = Action(name + '/GET_LIST_SUCCESS', list => ({
  list
}))

export const getFavouritesListFailure = Action(name + '/GET_LIST_FAILURE', error => ({
  error
}))

export const addFavouritesList = Action(name + '/ADD_LIST', payload => ({
  payload
}))

export const addFavouritesListSuccess = Action(name + '/ADD_LIST_SUCCESS')

export const addFavouritesListFailure = Action(name + '/ADD_LIST_FAILURE', error => ({
  error
}))

export const updateFavouritesList = Action(name + '/UPDATE_LIST', (id, payload) => ({
  id,
  payload
}))

export const updateFavouritesListSuccess = Action(name + '/UPDATE_LIST_SUCCESS', data => ({
  data: data.data.list
}))

export const updateFavouritesListFailure = Action(name + '/UPDATE_LIST_FAILURE', error => ({
  error
}))

export const deleteFavouritesList = Action(name + '/DELETE_LIST', id => ({
  id
}))

export const deleteFavouritesListSuccess = Action(name + '/DELETE_LIST_SUCCESS')

export const deleteFavouritesListFailure = Action(name + '/DELETE_LIST_FAILURE', error => ({
  error
}))

export const deleteFavouriteItem = Action(
  name + '/DELETE_LIST_ITEM',
  (id, filters, keywordIds) => ({
    id,
    filters,
    keywordIds
  })
)

export const deleteFavouriteItemSuccess = Action(name + '/DELETE_LIST_ITEM_SUCCESS')

export const deleteFavouriteItemFailure = Action(name + '/DELETE_LIST_ITEM_FAILURE', error => ({
  error
}))

export const clearFavouritesList = Action(name + '/CLEAR_LIST')

export const exportFavouritesList = Action(name + '/EXPORT_LIST', id => ({
  id
}))
